import { render, staticRenderFns } from "./CustomerDetailsModal.vue?vue&type=template&id=061b1e2c"
import script from "./CustomerDetailsModal.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports